import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { Button, SvgIcon, SimpleModal } from '@adsk/bim360-matrix-react-components';
import funnel from '../../../../../assets/images/icons/icon-funnel.svg';
import eye from '../../../../../assets/images/icons/icon-eye.svg';
import v1 from '../../../../../assets/images/icons/icon-V1.svg';

class PushpinVisibilityLearnMoreModal extends PureComponent {
  constructor(props) {
    super(props);

    this.learnMoreSectionIcons = [v1, funnel, eye];
  }

  renderLearnMoreModalSections() {
    return this.learnMoreSectionIcons.map((icon, index) => {
      return (
        <div key={`learnMoreSection${index + 1}`} className="PushpinVisibilityLearnMoreModal__section">
          <div className="PushpinVisibilityLearnMoreModal__section-icon">
            <SvgIcon width="20px" height="20px">{icon}</SvgIcon>
          </div>
          <div className="PushpinVisibilityLearnMoreModal__section-content">
            <div className="PushpinVisibilityLearnMoreModal__section-header">
              {T.translate(`preview.pushpinVisibilityLearnMore.section${index + 1}.header`)}
            </div>
            <div className="PushpinVisibilityLearnMoreModal__section-text">
              {T.translate(`preview.pushpinVisibilityLearnMore.section${index + 1}.content`)}
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const modalTitle = T.translate('preview.pushpinVisibilityLearnMore.modalHeader');
    const introductionText = T.translate('preview.pushpinVisibilityLearnMore.mainDescription');
    const confirmButtonText = T.translate('preview.pushpinVisibilityLearnMore.confirm');

    const footer = <Button styleType={Button.StyleType.PRIMARY} onClick={this.props.onDone}>{confirmButtonText}</Button>;

    return (
      <SimpleModal
        show={this.props.show}
        container={this.props.container}
        title={modalTitle}
        className="PushpinVisibilityLearnMoreModal"
        onExited={this.props.onDone}
        footer={footer}
        backdrop="static"
      >
        <div className="PushpinVisibilityLearnMoreModal__introduction">{introductionText}</div>
        {this.renderLearnMoreModalSections()}
      </SimpleModal>
    );
  }
}

PushpinVisibilityLearnMoreModal.displayName = 'PushpinVisibilityLearnMoreModal';

PushpinVisibilityLearnMoreModal.propTypes = {
  container: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default PushpinVisibilityLearnMoreModal;
